import * as React from 'react';
import { Edit, Form, Toolbar } from 'react-admin';
import { CardContent } from '@mui/material';

import { SupplierInputs } from './SupplierInputs';

import { SupplierAside } from './SupplierAside';

export const SupplierEdit = () => (
    <Edit
        aside={<SupplierAside link="show" />}
        actions={false}
        redirect="show"
        transform={values => ({
            ...values,
            ciclos: values.ciclos?.map((ciclo: { dias?: number | string }) => ({
                ...ciclo,
                dias: Number(ciclo.dias),
            })),
        })}
    >
        <Form>
            <CardContent>
                <SupplierInputs />
            </CardContent>
            <Toolbar />
        </Form>
    </Edit>
);
